import Registry from './models/Registry';
import { initSmoothScroll } from './smooth-scroll';
import { initVideoFallback } from './video-fallback';

class App {
  constructor(context) {
    this.registry = new Registry();
    this.contextInstance = this.initController(context);
    this.backgroundCanvas = null;

    this.updateBodyClasses();
    this.updateTriggerState();
  }

  initController(context) {
    const ContextClass = this.registry.getContext(context);
    return new ContextClass();
  }

  updateBodyClasses() {
    const newBodyClassesEl = document.querySelector('#body-classes');
    if (newBodyClassesEl && newBodyClassesEl.dataset.bodyClasses) {
      const newBodyClasses = newBodyClassesEl.dataset.bodyClasses;
      document.body.className = newBodyClasses;

      // Gestisci anche le classi dell'header e nav per il transparent header
      const hasTransparentHeader = newBodyClasses.includes('header-transparent'); // Attenzione: nel tuo PHP era 'header-transparent' o 'header_trasparente'? Verifica coerenza stringa
      const header = document.querySelector('#header');
      const nav = document.querySelector('#header nav');

      if (hasTransparentHeader) {
        if (header) header.classList.add('transparent');
        if (nav) nav.classList.add('transparent');
      } else {
        if (header) header.classList.remove('transparent');
        if (nav) nav.classList.remove('transparent');
      }

      // Show/hide the homepage-only footer block (added id="home-pile")
      try {
        const homePile = document.getElementById('home-pile');
        if (homePile) {
          // Consider both common WP classes for front page
          const isFront = document.body.classList.contains('front-page') || document.body.classList.contains('home');
          homePile.style.display = isFront ? '' : 'none';
        }
      } catch (e) {
        // silent
      }
    }
  }

  updateLogo() {
    // 1. LOGICA ESISTENTE: Logo Light vs Dark
    const logoLightEl = document.querySelector('#logo-light');
    
    // Se non troviamo l'elemento, assumiamo false per sicurezza, ma continuiamo l'esecuzione
    const isLogoLight = logoLightEl ? logoLightEl.dataset.logoLight === '1' : false;
    
    // Aggiorna l'attributo data nel MainMenu
    const mainMenu = document.querySelector('[data-g-component="MainMenu"]');
    if (mainMenu) {
      mainMenu.setAttribute('data-logo-light', isLogoLight ? '1' : '0');
    }

    // 2. NUOVA LOGICA: Trigger White/Gray
    // Cerchiamo i div nascosti che abbiamo aggiunto nel PHP
    const triggerWhiteEl = document.querySelector('#trigger-white');
    const triggerGrayEl = document.querySelector('#trigger-gray');
    const isTriggerWhite = triggerWhiteEl ? triggerWhiteEl.dataset.triggerWhite === '1' : false;
    const isTriggerGray = triggerGrayEl ? triggerGrayEl.dataset.triggerGray === '1' : false;
    
    // Selezioniamo il trigger (che è fuori dal container di Swup, quindi non si aggiorna da solo)
    const menuTrigger = document.querySelector('.menu-trigger');
    
    if (menuTrigger) {
      // Rimuovi tutte le classi trigger esistenti
      menuTrigger.classList.remove('trigger-white', 'trigger-gray');
      
      // Aggiungi la classe appropriata
      if (isTriggerWhite) {
        menuTrigger.classList.add('trigger-white');
      } else if (isTriggerGray) {
        menuTrigger.classList.add('trigger-gray');
      }
      
      // Gestisci la classe dark-trigger basata su isLogoLight
      if (isLogoLight) {
        menuTrigger.classList.remove('dark-trigger');
      } else {
        menuTrigger.classList.add('dark-trigger');
      }
      
      // Aggiorna il colore del testo del trigger
      const triggerSpan = menuTrigger.querySelector('span');
      if (triggerSpan) {
        if (isLogoLight) {
          triggerSpan.classList.remove('text-white');
          triggerSpan.classList.add('text-black');
        } else {
          triggerSpan.classList.remove('text-black');
          triggerSpan.classList.add('text-white');
        }
      }
      
      // Aggiorna il colore delle linee del trigger (solo desktop)
      // Mobile ha sempre max-md:!bg-black, quindi gestiamo solo le classi md:
      const triggerLines = menuTrigger.querySelectorAll('.menu-trigger-line');
      triggerLines.forEach(line => {
        if (isLogoLight) {
          line.classList.remove('md:bg-white');
          line.classList.add('md:bg-black');
        } else {
          line.classList.remove('md:bg-black');
          line.classList.add('md:bg-white');
        }
      });
    }
    
    // Aggiorna il colore del testo "Creative Agency"
    const creativeAgencyText = document.querySelector('.creative-agency-text span');
    if (creativeAgencyText) {
      // Se è trigger white/gray o logo light, usa span-gray, altrimenti dark_gray
      if (isLogoLight || isTriggerWhite || isTriggerGray) {
        creativeAgencyText.classList.remove('text-span-dark_gray');
        creativeAgencyText.classList.add('text-span-gray');
      } else {
        creativeAgencyText.classList.remove('text-span-gray');
        creativeAgencyText.classList.add('text-span-dark_gray');
      }
    }
    
    // 3. LOGICA ESISTENTE: Cambio Immagine Logo
    // Trova SOLO il logo desktop (quello con classe max-md:hidden)
    // Il logo mobile rimane sempre invariato (sempre logo normale)
    const logoDesktop = document.querySelector('#header .logo-container a img.max-md\\:hidden');
    if (!logoDesktop) return;
    
    // Prendi gli URL dei loghi dai data attributes
    const logoUrlsEl = document.querySelector('#logo-urls');
    if (!logoUrlsEl) return;
    
    const logoNormalUrl = logoUrlsEl.dataset.logoNormal;
    const logoLightUrl = logoUrlsEl.dataset.logoLightUrl;
    
    // Aggiorna SOLO il logo desktop in base al flag isLogoLight
    // Il logo mobile (md:hidden) non viene toccato e rimane sempre normale
    if (isLogoLight && logoLightUrl) {
      logoDesktop.src = logoLightUrl;
    } else if (logoNormalUrl) {
      logoDesktop.src = logoNormalUrl;
    }
  }

  /**
   * Update trigger state independently (called after DOM is ready)
   */
  updateTriggerState() {
    const triggerWhiteEl = document.querySelector('#trigger-white');
    const triggerGrayEl = document.querySelector('#trigger-gray');
    const isTriggerWhite = triggerWhiteEl ? triggerWhiteEl.dataset.triggerWhite === '1' : false;
    const isTriggerGray = triggerGrayEl ? triggerGrayEl.dataset.triggerGray === '1' : false;
    
    const menuTrigger = document.querySelector('.menu-trigger');
    const header = document.querySelector('#header');
    
    if (!menuTrigger) return;

    // Remove all existing trigger classes
    menuTrigger.classList.remove('trigger-white', 'trigger-gray');
    
    // Add appropriate class
    if (isTriggerWhite) {
      menuTrigger.classList.add('trigger-white');
    } else if (isTriggerGray) {
      menuTrigger.classList.add('trigger-gray');
    }
    
    // Update mobile header classes based on desktop trigger
    if (header) {
      header.classList.remove('mobile-dark', 'mobile-white', 'mobile-gray');
      
      const logoLightEl = document.querySelector('#logo-light');
      const isLogoLight = logoLightEl ? logoLightEl.dataset.logoLight === '1' : false;
      
      if (isTriggerWhite) {
        // Desktop trigger white → mobile white
        header.classList.add('mobile-white');
      } else if (isTriggerGray) {
        // Desktop trigger gray → mobile gray
        header.classList.add('mobile-gray');
      } else if (!isLogoLight) {
        // Desktop dark-trigger → mobile dark
        header.classList.add('mobile-dark');
      }
      // else: logo light (home) → usa default gray mobile
    }

    // Update trigger colors based on current state
    const logoLightEl = document.querySelector('#logo-light');
    const isLogoLight = logoLightEl ? logoLightEl.dataset.logoLight === '1' : false;

    const triggerSpan = menuTrigger.querySelector('span');
    if (triggerSpan) {
      if (isLogoLight) {
        triggerSpan.classList.remove('text-white');
        triggerSpan.classList.add('text-black');
      } else {
        triggerSpan.classList.remove('text-black');
        triggerSpan.classList.add('text-white');
      }
    }

    const triggerLines = menuTrigger.querySelectorAll('.menu-trigger-line');
    triggerLines.forEach(line => {
      if (isLogoLight) {
        line.classList.remove('md:bg-white');
        line.classList.add('md:bg-black');
      } else {
        line.classList.remove('md:bg-black');
        line.classList.add('md:bg-white');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const context = typeof _gTheme_ !== 'undefined' ? _gTheme_ : {};
  new App(context);
  initSmoothScroll();
  initVideoFallback();
});
